/* eslint-disable import/prefer-default-export */
import useSWR from "swr";
import { getCacheSnapshot } from "../services/cache-service";
import { CacheSnapshot } from "../services/cache-types";

export const CACHE_SNAPSHOT_KEY = "/cache/snapshot";

export const useCacheSnapshot = () => {
  const { data, error, isLoading, mutate } = useSWR<CacheSnapshot>(
    CACHE_SNAPSHOT_KEY,
    getCacheSnapshot,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  const refresh = async () => {
    await mutate();
  };

  return { data, error, isLoading, refresh };
};
